module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/1-2312109212de282462d44c6bcdbbf38c.jpg";